import React, { useState } from 'react';

import close from "../../../assets/images/modal-key-entry/close.svg";
import buenasNoches from "../../../assets/images/modal-key-entry/buenasNoches.png";
import intimaWear from "../../../assets/images/modal-key-entry/intimaWear.png";
import "./modal-key-entry.scss";

const ModalKeyEntry = props => {

    const {
        showModalKey,
        setShowModalKey,
        valueInput,
        setValueInput,
        addKeys,
        myKeys,
        keySubmit,
    } = props;

    const handleClick = (e) => {
        addKeys(myKeys, valueInput)

        if (keySubmit.length < 1) {
            setShowModalKey(false)
            setValueInput(null)
        } else {
            setShowModalKey(false)
            setValueInput(null)
        }
    }

    return (
        <>
            {
                showModalKey ?
                    <div className="f-modal-key-entry">
                        <button className="f-modal-key-entry__close" onClick={() => (setShowModalKey(false), setValueInput(null))}>
                            <img src={close} alt="close" />
                        </button>

                        <h1 className="f-modal-key-entry__title">
                            ¿<span>Cuál es el producto</span>
                            <br />
                            el que estás ingresando <span>tu clave</span>?
                        </h1>

                        <form action="">
                            <div className="f-modal-key-entry__sectionProducts">
                                <div className="f-modal-key-entry__sectionProducts-productOne">
                                    <label htmlFor="MC">
                                        <img src={buenasNoches} alt="buenasNoches" />
                                    </label>
                                    <input className={`${valueInput === "MC" ? "input-active" : null}`}
                                        onChange={(e) => setValueInput(e.target.value)} type="radio"
                                        name="product" id="MC" value="MC" />
                                </div>
                                <div className="f-modal-key-entry__sectionProducts-productTwo">
                                    <label htmlFor="S2">
                                        <img src={intimaWear} alt="intimaWear" />
                                    </label>
                                    <input className={`${valueInput === "S2" ? "input-active" : null}`}
                                        onChange={(e) => setValueInput(e.target.value)} type="radio"
                                        name="product" id="S2" value="S2" />
                                </div>
                            </div>
                        </form>

                        <button className="f-modal-key-entry__button" onClick={() => handleClick()} disabled={!valueInput}>Enviar</button>
                    </div>
                    :
                    null
            }
        </>
    )
}

export default ModalKeyEntry